import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Send, Check } from "lucide-react";

export default function AdminNotifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async ({ silent = false } = {}) => {
    try {
      const { data } = await api.get("/admin/notifications?unread_only=true");
      setItems(data);
    } finally { if (!silent) setLoading(false); }
  };
  useEffect(() => {
    load();
    const onEvent = () => load({ silent: true });
    window.addEventListener("afr-admin-event", onEvent);
    return () => window.removeEventListener("afr-admin-event", onEvent);
  }, []);

  const markSent = async (id) => {
    try {
      await api.post(`/admin/notifications/${id}/mark-sent`);
      toast.success("Marked sent");
      load({ silent: true });
    } catch {
      toast.error("Failed");
    }
  };

  return (
    <div>
      <div className="px-6 pt-8 pb-4">
        <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#3CFF7E] font-display mb-1">Admin</div>
        <h1 className="font-display text-3xl font-black tracking-tight">Job Alerts</h1>
        <p className="text-sm text-[#9CA3AF] mt-1">
          {loading ? "Loading..." : `${items.length} unread · realtime alerts`}
        </p>
      </div>

      <div className="px-6 pb-6 space-y-2">
        {!loading && items.length === 0 && (
          <div className="border border-dashed border-white/10 rounded-md p-8 text-center text-sm text-[#9CA3AF]">
            No new job alerts. New jobs appear here in realtime.
          </div>
        )}
        {items.map((n) => (
          <div key={n.id} className="border border-white/10 bg-[#111827] rounded-md p-3" data-testid={`notif-${n.id}`}>
            <div className="flex items-center justify-between">
              <div className="min-w-0 flex-1">
                <div className="font-display font-bold text-sm text-white">{n.clientName}</div>
                <div className="text-xs text-[#9CA3AF]">
                  {n.serviceType} · {n.jobType} {n.scheduledDate ? `· ${new Date(n.scheduledDate).toLocaleString("en-ZA", { dateStyle: "medium", timeStyle: "short" })}` : ""}
                </div>
                <div className="text-xs text-[#9CA3AF] truncate mt-0.5">{n.location}</div>
              </div>
              <span className="status-pill status-pending">New</span>
            </div>
            <pre className="mt-2 p-2 bg-[#0A0A0A] rounded text-[11px] text-[#9CA3AF] whitespace-pre-wrap font-mono">{n.message}</pre>
            <div className="grid grid-cols-2 gap-2 mt-2">
              <a
                href={n.waUrl}
                target="_blank"
                rel="noreferrer"
                onClick={() => setTimeout(() => markSent(n.id), 500)}
                data-testid={`send-wa-${n.id}`}
                className="h-10 bg-[#25D366] text-[#0A0A0A] rounded-md flex items-center justify-center gap-1 text-xs font-display font-bold uppercase tracking-wider"
              >
                <Send size={14} /> Send WhatsApp
              </a>
              <button
                onClick={() => markSent(n.id)}
                data-testid={`dismiss-${n.id}`}
                className="h-10 border border-white/10 text-[#9CA3AF] rounded-md flex items-center justify-center gap-1 text-xs font-display font-bold uppercase tracking-wider"
              >
                <Check size={14} /> Mark Sent
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
